import { Search } from 'lucide-react';
import { clsx } from 'clsx';

type Props = {
  categories: ReadonlyArray<{ label: string; count: number }>;
  total: number;
  active: string | null;
  onSelect: (c: string | null) => void;
};

export default function BlogCategoryStripV2({ categories, total, active, onSelect }: Props) {
  return (
    <section className="sticky top-0 z-50 border-b-2 border-charcoal-800 bg-white shadow-[0_4px_0_0_#1A1A2E]">
      <div className="mx-auto flex max-w-7xl items-center gap-3 overflow-x-auto px-6 py-4 md:px-8">
        <button
          type="button"
          onClick={() => onSelect(null)}
          className={clsx(
            'group inline-flex flex-shrink-0 items-center gap-2 border-2 px-3 py-2 font-marketing-display text-[13px] font-bold transition-all cursor-pointer',
            active === null
              ? 'border-charcoal-800 bg-lime-500 text-charcoal-800 shadow-neobrutal-2'
              : 'border-transparent text-charcoal-700 hover:border-charcoal-800 hover:bg-paper',
          )}
        >
          Tout
          <span
            className={clsx(
              'font-marketing-mono text-[10px]',
              active === null ? 'text-charcoal-700' : 'text-charcoal-400',
            )}
          >
            {total}
          </span>
        </button>

        {categories.map((c) => {
          const isActive = active === c.label;
          return (
            <button
              key={c.label}
              type="button"
              onClick={() => onSelect(c.label)}
              className={clsx(
                'inline-flex flex-shrink-0 items-center gap-2 border-2 px-3 py-2 font-marketing-display text-[13px] font-bold transition-all cursor-pointer',
                isActive
                  ? 'border-charcoal-800 bg-lime-500 text-charcoal-800 shadow-neobrutal-2'
                  : 'border-transparent text-charcoal-700 hover:border-charcoal-800 hover:bg-paper',
              )}
            >
              {c.label}
              <span
                className={clsx(
                  'font-marketing-mono text-[10px]',
                  isActive ? 'text-charcoal-700' : 'text-charcoal-400',
                )}
              >
                {c.count}
              </span>
            </button>
          );
        })}

        <span className="ml-auto h-5 w-px flex-shrink-0 bg-charcoal-200" />

        <button
          type="button"
          className="flex flex-shrink-0 items-center gap-2 border-2 border-charcoal-800 bg-paper px-3 py-2 font-marketing-display text-[13px] font-bold text-charcoal-800 shadow-neobrutal-2 transition-transform hover:-translate-x-[1px] hover:-translate-y-[1px] hover:shadow-neobrutal-4 cursor-pointer"
          aria-label="Rechercher un article"
        >
          <Search className="h-4 w-4" strokeWidth={2.4} />
          <span className="hidden md:inline">Rechercher</span>
        </button>
      </div>
    </section>
  );
}
